import React, { useRef, useEffect } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';
import Hero from '../components/Hero';
import CraftSection from '../components/CraftSection';
// import Testimonials from '../components/Testimonials';
import TestimonialsNew from '../components/TestimonialsNew';

const Home = ({ openModal, setHeroHeight }) => {
  const heroRef = useRef(null);

  useEffect(() => {
    if (heroRef.current) {
      setHeroHeight(heroRef.current.offsetHeight);
    }
  }, [setHeroHeight]);

  return (
    <>
      <Helmet>
        <title>Mackintosh's Kilts | Bespoke Scottish Kilts | Traditional Kiltmakers</title>
        <meta name="description" content="Discover Mackintosh's Kilts - Four generations of master kiltmakers crafting bespoke Scottish kilts. Traditional craftsmanship meets modern artistry. Commission your custom kilt today." />
        <meta name="keywords" content="Scottish kilts, bespoke kilts, traditional kiltmaking, custom kilts, tartan kilts, Highland dress, Scottish heritage, kilt commission, Glasgow kiltmaker, St Andrews kilts" />
        <meta property="og:title" content="Mackintosh's Kilts | Bespoke Scottish Kilts" />
        <meta property="og:description" content="Four generations of master kiltmakers crafting bespoke Scottish kilts with traditional craftsmanship and modern artistry." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.jamesmackintosh.co.uk/" />
        <link rel="canonical" href="https://www.jamesmackintosh.co.uk/" />
      </Helmet>
      <Hero onBookAppointment={openModal} heroRef={heroRef} />
      <CraftSection />
      {/* <Testimonials /> */}
      <TestimonialsNew />
    </>
  );
};

export default Home;
